import React from 'react';

// Unchecked radio icon (16px circle, 1.5px border, transparent fill)
const UncheckedRadioIcon = (
  <span
    style={{
      width: 16,
      height: 16,
      borderRadius: '50%',
      border: '1.5px solid currentColor',
      backgroundColor: 'transparent',
      display: 'inline-block',
      boxSizing: 'border-box'
    }}
  />
);

// Checked radio icon (16px circle, teal border, 6px center dot, transparent fill)
const CheckedRadioIcon = (
  <span
    style={{
      width: 16,
      height: 16,
      borderRadius: '50%',
      border: '1.5px solid #14B8A6',
      backgroundColor: 'transparent',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box'
    }}
  >
    <span
      style={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: '#14B8A6',
        display: 'block'
      }}
    />
  </span>
);

export default function Radio(theme) {
  const isDark = theme?.palette?.mode === 'dark';

  return {
    MuiRadio: {
      defaultProps: {
        icon: UncheckedRadioIcon,
        checkedIcon: CheckedRadioIcon
      },
      styleOverrides: {
        root: {
          color: isDark ? 'rgba(255, 255, 255, 0.10)' : '#CBD5E1',
          padding: '6px',
          '&:hover': {
            backgroundColor: isDark ? 'rgba(20, 184, 166, 0.08)' : 'rgba(20, 184, 166, 0.04)'
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '13px',
          fontWeight: 400,
          color: isDark ? '#E8EAEE' : '#1E293B',
          userSelect: 'none'
        }
      }
    }
  };
}
